//Get Setting
export const GET_SETTING = "GET_SETTING";

//Update Setting
export const UPDATE_SETTING = "UPDATE_SETTING";


//Toggle Switch
export const HANDLE_TOGGLE_SWITCH = "HANDLE_TOGGLE_SWITCH";